module.exports = __webpack_public_path__ + "static/media/angela_hao.a55043dd.png";